@if (content) {
<shell></shell>
<div [ngClass]="content?.variant === 'light' ? 'bg-col-51' : 'bg-col-1'"
     class="z-1 pos-relative">
    <div class="wrap-x ">
        <div class="w-12 flex flex-column p-t-8 p-b-0-x p-b-0-l p-l-4-s p-r-4-s p-l-4-m p-r-4-m p-a-10-l">
            @if(!content.hideBreadcrumb && !hideBreadcrumb) {
            <breadcrumbs [variant]="content?.variant"
                         class="m-b-8 m-b-4-m m-b-4-s m-t-5-x m-t-5-l block no-scrollbar overflow-auto flex flex-justify-left">
            </breadcrumbs>
            }

            <div class="flex flex-column">
                <div class="m-b-8 m-b-4-m m-b-4-s"
                     [ngClass]="content?.variant === 'light' ? 'col-1' : 'col-w'">
                    @if (content?.title || categoryName) {
                    <div class="h2 w-12 m-b-8 m-b-4-m m-b-4-s"
                         [innerHTML]="content?.title || categoryName"></div>
                    }
                    @if (content?.description || categoryDescription) {
                    <view-more class=" w-8 w-12-s w-12-m"
                               [text]="content?.description || categoryDescription"></view-more>
                    }
                </div>
            </div>
        </div>
        @if(content?.links?.length > 0) {
        <div class="w-12  p-l-4-s p-r-4-s p-l-4-m p-r-4-m p-b-8 p-b-10-l p-a-10-l p-b-10-x left _drag-container no-wrap"
             dragScroll>
            @for (item of content.links; track $index) {
            <div class="inline-flex flex-middle va-t p-a-2 p-l-3 p-r-3 _drag-item"
                 [class.m-r-3]="!$last">
                <href [link]="item.url">
                    <div class="inline-flex flex-middle">
                        @if (item.image) {
                        <img draggable="false"
                             class="overflow-hidden b-radius-max m-r-2 _drag-item"
                             [width]="44"
                             [ratio]="1"
                             [dfImage]="item.image">

                        }
                        <p class="s2 center overflow-hidden"
                           [ngClass]="content.variant === 'light' ? 'col-1' : 'col-w'"
                           *iCms="'text' of item">
                        </p>
                    </div>
                </href>
            </div>
            }
        </div>
        }
    </div>
</div>

}
